// extracted by mini-css-extract-plugin
export default {"page":"ResearchPage_page__JjWbg","content":"ResearchPage_content__NBhWr"};